// extracted by css-extract-rspack-plugin
export default {"cls1":"Tooltip-cls1_CiV","cls2":"Tooltip-cls2_fP4 Tooltip-cls1_CiV"};